"use client";

import dynamic from "next/dynamic";
import { ThemeScope } from "@/components/theme/ThemeScope";

/* Non-SSR-critical storefront utilities — excluded from server bundle. */

const RestoreScroll = dynamic(
  () => import("@/components/layout/RestoreScroll").then(m => ({ default: m.RestoreScroll })),
  { ssr: false },
);
const AdminEntryLink = dynamic(
  () => import("@/components/layout/AdminEntryLink").then(m => ({ default: m.AdminEntryLink })),
  { ssr: false },
);
const FloristEntryLink = dynamic(
  () => import("@/components/layout/FloristEntryLink").then(m => ({ default: m.FloristEntryLink })),
  { ssr: false },
);
const RoleLandingRedirect = dynamic(
  () => import("@/components/layout/RoleLandingRedirect").then(m => ({ default: m.RoleLandingRedirect })),
  { ssr: false },
);
const InstallPrompt = dynamic(
  () => import("@/components/pwa/InstallPrompt").then(m => ({ default: m.InstallPrompt })),
  { ssr: false },
);
const ChatWidget = dynamic(
  () => import("@/components/chat/ChatWidget").then(m => ({ default: m.ChatWidget })),
  { ssr: false },
);
const UtmCapture = dynamic(
  () => import("@/components/analytics/UtmCapture").then(m => ({ default: m.UtmCapture })),
  { ssr: false },
);

export function MainLayoutClient() {
  return (
    <>
      {/* Force LIGHT on every customer route, even on SPA nav in from a staff
          portal — the storefront is light-only (a staff Dark/Auto preference
          must never follow them onto customer pages). The scope is derived from
          the pathname, so it needs no prop. */}
      <ThemeScope />
      <RestoreScroll />
      <RoleLandingRedirect />
      <AdminEntryLink />
      <FloristEntryLink />
      <ChatWidget />
      <InstallPrompt />
      <UtmCapture />
    </>
  );
}
